import { loadScreeningDatesByQuery, loadShowtimesForBusinessDate, loadShowtimesForFirstBusinessDate } from '@vista/omnichannel-components-domain';
/**
 * Asynchronously loads screening dates from the API
 */
export const loadScreeningDates = async (query) => {
    // Fetch Screening Dates
    return loadScreeningDatesByQuery(query);
};
/**
 * Asynchronously loads the showtimes for the current query.
 * If a businessDate is provided, showtimes are loaded for that date.
 * If no businessDate is provided, showtimes are loaded for the first date with showtimes.
 */
export const loadShowtimes = async (query, businessDate) => {
    if (businessDate)
        return loadShowtimesForBusinessDate(query, businessDate);
    else
        return loadShowtimesForFirstBusinessDate(query);
};
export const isDateShowtimePickerPropsWithFilmIds = (props) => {
    return props.filmIds !== undefined;
};
